import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import Cross from '../../SvgIcon/Icons/Cross';
import PillControl from '../PillControl';
const COMPONENT_NAME = 'Pill';
const Pill = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, children, controlIcon = /*#__PURE__*/ React.createElement(Cross, null), onClick, disabled, pillId, ...other } = props;
    return /*#__PURE__*/ React.createElement("span", {
        className: cx('Pill', {
            'Pill--disabled': disabled
        }, className),
        ...other
    }, children, /*#__PURE__*/ React.createElement(PillControl, {
        icon: controlIcon,
        onClick: disabled ? undefined : (e)=>onClick(e, pillId)
    }));
};
Pill.propTypes = {
    /**
	 * Children will be rendered within the `Pill`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Icon which will be displayed in PillControl
	 */ controlIcon: PropTypes.node,
    /**
	 * Pill is disabled
	 */ disabled: PropTypes.bool,
    /**
	 * Callback function fired when button is clicked.
	 *
	 * @param {object} event event targeting the element.
	 * @param {object} key.
	 * @return {undefined} Nothin'
	 */ onClick: PropTypes.func,
    /**
	 * unique value for pill representation
	 */ pillId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};
export default Pill;
